var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-II",
    stroke: "none",
    strokeWidth: 1,
    fill: "",
    fillRule: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "2_step_1Details_visible",
    transform: "translate(-1133.000000, -393.000000)",
    fill: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(592.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(541.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6,16 C1.1904,16 0.7808,15.8432 0.4688,15.5312 C-0.1568,14.9056 -0.1568,13.8944 0.4688,13.2688 L11.7824,1.9552 C12.408,1.3296 13.4208,1.3296 14.0448,1.9552 C14.6704,2.5792 14.6704,3.592 14.0448,4.2176 L2.7312,15.5312 C2.4192,15.8432 2.0096,16 1.6,16",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.78288,15.5312 L0.46928,4.2176 C-0.15632,3.592 -0.15632,2.5792 0.46928,1.9552 C1.09328,1.3296 2.10608,1.3296 2.73168,1.9552 L14.04528,13.2688 C14.67088,13.8944 14.67088,14.9056 14.04528,15.5312 C13.73328,15.8432 13.32368,16 12.91408,16 C12.50448,16 12.09488,15.8432 11.78288,15.5312 Z",
    id: "Fill-4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.6e1b59b82863e095eb612992ff6c2707.svg";
export { ForwardRef as ReactComponent };